const getCookies = cookieName => {
  const cookies = document.cookie.split(";");
  return cookies
    .filter(cookie => cookie.includes(`${cookieName}=`))
    .map(cookie => cookie.replace(`${cookieName}=`, "").trim())
    .map(cookie => decodeURIComponent(cookie));
};

export default getCookies;
